import React, { useEffect } from "react";
import { Grid, Tabs, Tab, Typography } from "@material-ui/core";
import clsx from "clsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCog } from "@fortawesome/pro-duotone-svg-icons";
import useThemeContext from "../../hooks/useThemeSwitch.js";
import { useFeatureFlag } from "../../hooks/useFeatureFlags";
import useHasPermissions from "../../hooks/useHasPermissions";
import { setRootContainerWidth } from "../../reducers/layout/layoutReducer.js";
import { useStyles } from "./styles.js";
import OneParkAdminContainer from "../../components/OneParkAdmin/OneParkAdminContainer.jsx";

const OneParkAdminPage = () => {
  const classes = useStyles();
  const { layoutReducer } = useThemeContext();
  const [, layoutDispatch] = layoutReducer;
  const isOneParkEnabled = useFeatureFlag("ONEpark");
  const { hasPermissions } = useHasPermissions();
  const hasOneParkPermission = hasPermissions(["ONEparkAdmin"]);
  const canAccessOnePark = isOneParkEnabled && hasOneParkPermission;

  useEffect(() => {
    layoutDispatch({ type: setRootContainerWidth, payload: false });
  }, [layoutDispatch]);

  return (
    <>
      {canAccessOnePark && (
        <>
          <Grid item xs={12}>
            <Tabs
              centered
              className={clsx("onepark-tabs", classes.oneParkTab)}
              variant="fullWidth"
              value="tabAdmin"
            >
              <Tab
                value="tabAdmin"
                icon={<FontAwesomeIcon icon={faCog} size="2xl" />}
                label="Admin"
                data-id="onepark-admin-tab"
                data-testid="onepark-admin-tab"
              />
            </Tabs>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle1" className={classes.subHeader}>
              ONEpark Admin
            </Typography>
          </Grid>
          <OneParkAdminContainer />
        </>
      )}
    </>
  );
};

export default OneParkAdminPage;
